import conversation from './conversation'
import { ADD_CONVERSATION, SELECT_CONVERSATION, REMOVE_CONVERSATION, REMOVE_ALL_CONVERSATIONS } from '../../types/conversations'
import inchatTypes from '../../inchat/types'

const notAlowedTypes = Object.keys(inchatTypes)
const initialState = {}

/**
 * Conversations state management
 * @param {Object} state Actual conversations state
 * @param {Object} action Current action to perform
 */
function conversations(state = initialState, action) {
  if (action.type === REMOVE_ALL_CONVERSATIONS) return initialState
  if (!action.userId) return state
  if (notAlowedTypes.includes(action.type)) return state
  switch (action.type) {
    case ADD_CONVERSATION: {
      return Object.assign({}, state, {
        [action.userId]: conversation(state[action.userId], action)
      })
    }
    case SELECT_CONVERSATION: {
      if (!state[action.userId]) return state
      return state[action.userId]
    }
    case REMOVE_CONVERSATION: {
      if (!state[action.userId]) return state
      const newState = Object.assign({}, state)
      delete newState[action.userId]
      return newState
    }
    default: {
      return Object.assign({}, state, {
        [action.userId]: conversation(state[action.userId], action),
      })
    }
  }
}

export default conversations
